import {
  useEffect,
  useMemo,
  useState
} from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { langApi } from 'api'
import { Input, Div } from 'ui'
import { useSnackbar } from 'hooks'

import { ReactComponent as WorldSVG } from 'assets/icons/world.svg'
import { ReactComponent as LangSVG } from 'assets/icons/snackbar/lang.svg'
import { ReactComponent as CheckSVG } from 'assets/icons/check.svg'


const LangSelector = ({ isFull }) => {

  const { t, i18n } = useTranslation()

  const { Snackbar } = useSnackbar('error')

  const { data: langs } = langApi.useGetLangs()
  
  const langOptions = useMemo(
    () => langs.map( l => ({
      value: l.lang,
      label: l.nameNative
    })
  ), [langs])

  const queryClient = useQueryClient()

  const [selected, setSelected] = useState()

  const width = isFull ? '100%' : 70


  const handleLang = (newSelected) => {
    if (newSelected.value === selected.value) return

    localStorage.setItem('i18nextLng', newSelected.value)
    setSelected(newSelected)
    i18n.changeLanguage(newSelected.value)
    queryClient.invalidateQueries('lang')
    Snackbar.open({
      message: t('lang:changeMessage'),
      icon: LangSVG
    })
  }

  const formatOptionLabel = ({ value, label }, meta) => {
    if (meta.context === 'value') {
      return value.toUpperCase()
    }
  
    const isSelected = meta.selectValue[0]?.value === value

    return (
      <Div
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        minWidth={100}
      >
        {label}
        {isSelected ? <CheckSVG height={20} /> : ''}
      </Div>
    )
  }


  useEffect(() => {
    if (!langOptions.length) return 

    const lang = localStorage.getItem('i18nextLng')
    const current = langOptions.find(l => l.value === lang)
    setSelected(current)
  }, [langOptions])


  return (
    <Div width={width} minWidth={width}>
      <Input.Select
        options={langOptions}
        placeholder=' '
        size='small'
        hideChevron
        icon={WorldSVG}
        isSearchable={false}
        selected={selected}
        onChange={handleLang}
        formatOptionLabel={formatOptionLabel}
      />
    </Div>
  )
}

export default LangSelector